import { render } from "./ViewDetachementPage.vue?vue&type=template&id=354e033e&ts=true"
import script from "./ViewDetachementPage.vue?vue&type=script&lang=ts"
export * from "./ViewDetachementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__